<template>
	<div class="loginbg">
		<div class="login_logo"></div>
		<div class="popup_center ">
		  <div class="box_size">
		  <div class="login_img"></div>
		    <div class="login">
		      <div class="user_tab"  style="margin-top: 50px;">
		        <ul>
		          <li class="active" style="width:100%"><a>重置密码</a></li>
		        </ul>
		      </div>
		      <div class="login_input">
		        <ul>
		          <li>
		            <input type="password" placeholder="输入密码" v-model="password1" ref="password1">
		          </li>
		          <li>
		            <input type="password" placeholder="再一次输入密码" v-model="password2" ref="password2">
		          </li>
		        </ul>
		      </div>
		      <div class="login_bot">
		        <span><a @click="submit">提交</a></span> </div>
		    </div>
		  </div>
		</div>
		<div class="bot_tip">
			<span> <a>联系我们</a> | <a>法律声明</a> | <a>下载中心</a> | <a>网站地图</a></span>  
			<em>©2017 青岛迪迪网络科技有限公司 All Rights Reserved.</em>
		</div>
	    <!--页面tab弹框组件开始-->				
		<main-modal ref="modal1" size="small" title="提示" >
			<p v-text="tipContent"></p>	
			<div slot="footer">
				<button class="btn btn-primary" @click="closetip">关闭</button>
			</div>
		</main-modal>
	</div>
</template>

<script>
    import MainModal from 'components/common/MainModal'
    import {OPERATE_EXCEPTION,RESET_VEHICLE_SUCCESS,LOGIN_PASSWORD_EMPTY,PASSWORD_EQUAL} from 'static/message'
    
	export default {
		name: 'ResetVehiclePassword',
		components: {
			MainModal
		},
		data() {
			return {
				token:this.$route.params.token,
				password1:'',
				password2:'',
				tipContent:''
			}
		},
		methods: {
			submit(){
				if(!this.password1) {
					this.opentip(LOGIN_PASSWORD_EMPTY);
					this.$refs.password1.focus();
					return;
				}
				if(!this.password2) {
					this.opentip(LOGIN_PASSWORD_EMPTY);
					this.$refs.password2.focus();
					return;
				}
				if(this.password1 !== this.password2) {
					this.opentip(PASSWORD_EQUAL);
					this.$refs.password2.focus();
					return;
				}
				let param = {
					md5Str:this.token,
					password:this.password2
				}
				this.$http.put(process.env.API_ROOT + '/noauth/vehicles/ower/password/' + this.token + '?password=' + this.password2) 
	    		.then((response)=>{
						if(response.body.status===200){
							this.opentip(RESET_VEHICLE_SUCCESS);
						}else{
							this.opentip(response.body.message);
						}
					},(response)=>{
						this.opentip(response.body.message);
					})
	    		.catch((response)=>{
					this.opentip(LOGIN_EXCEPTION);
				})
			},
			closetip(){
				this.$refs.modal1.close();	
			},
			opentip(message){
				this.tipContent=message;
				this.$refs.modal1.open();	
			},
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// ResetVehiclePassword.vue?66cd4316